var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUploadFolder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_2269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.037 63.4389H19.3091C18.0468 63.4389 17.0234 62.4142 17.0234 61.1503V15.0996C17.0234 11.7308 19.7508 9 23.1154 9H65.9088C69.2733 9 72.0007 11.7308 72.0007 15.0996V58.469C72.0007 61.2141 69.7787 63.4389 67.037 63.4389Z",
    fill: "url(#paint0_linear_159_2269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3091 63.4396H67.037C69.7787 63.4396 72.0007 61.2142 72.0007 58.4697V19.1357L67.254 14.3831C66.4789 13.5168 65.3534 12.9712 64.1004 12.9712H17.4058C17.1591 13.634 17.0234 14.3512 17.0234 15.1003V61.151C17.0234 62.4149 18.0468 63.4396 19.3091 63.4396Z",
    fill: "url(#paint1_linear_159_2269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1005 63.4401H8.48108C6.14319 63.4401 4.24805 61.5426 4.24805 59.2017V17.2096C4.24805 14.8687 6.14319 12.9712 8.48108 12.9712H64.1005C66.4384 12.9712 68.3335 14.8687 68.3335 17.2096V59.2017C68.3335 61.5426 66.4384 63.4401 64.1005 63.4401Z",
    fill: "url(#paint2_linear_159_2269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4426 19.8863C61.2836 18.657 59.6417 17.8887 57.8196 17.8887H4.24805V59.2016C4.24805 61.5424 6.14319 63.4399 8.48108 63.4399H64.1005C66.4384 63.4399 68.3335 61.5424 68.3335 59.2016V25.7846L62.4426 19.8863Z",
    fill: "url(#paint3_linear_159_2269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6024 13.4522C18.7619 10.8111 16.3114 9.01807 13.5434 9.01807H6.35944C2.84711 9.01807 0 11.8688 0 15.3855V57.1494C0 60.6222 2.81195 63.4377 6.28033 63.4377H65.9147C64.9556 63.4377 64.1783 62.6594 64.1783 61.6991V24.2539C64.1783 20.7377 61.3312 17.8864 57.8188 17.8864H25.6619C22.8933 17.8864 20.4428 16.0934 19.6024 13.4522Z",
    fill: "url(#paint4_linear_159_2269)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_159_2269",
    x1: -12.0007,
    y1: 12.9279,
    x2: 73.0902,
    y2: 12.9279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177BF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_159_2269",
    x1: 32.7266,
    y1: 32.5353,
    x2: 68.6817,
    y2: 63.0881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177BF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_159_2269",
    x1: 36.2907,
    y1: -4.98148,
    x2: 36.2907,
    y2: 63.9727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FAF8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#ECEEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#D5DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#B5C4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B5D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_159_2269",
    x1: 67.9008,
    y1: 43.9487,
    x2: 49.9736,
    y2: 42.2562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1B5D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6699,
    stopColor: "#8190A4",
    stopOpacity: 0.670588
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_159_2269",
    x1: 32.9573,
    y1: 63.4377,
    x2: 32.9573,
    y2: 9.01807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177BF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAD9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_2269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadFolder);
export default __webpack_public_path__ + "static/media/icon_upload_folder.850a78f109db9f0e9b596de6a172019d.svg";
export { ForwardRef as ReactComponent };